import React from 'react'
import {ModeleMotif, modeleMotifRefusInitValues} from '../../../components/Models'
import {useNavigate} from 'react-router-dom'
import {createMotif} from '../../../components/requests'
import {MotifRefusForm} from './components/MotifRefusForm'

const MotifRefusAddPage = () => {
  const navigate = useNavigate();

  const submitForm = async (fieldsToUpdate: Partial<ModeleMotif>, callback): Promise<void> => {
    const updatedData = Object.assign({...modeleMotifRefusInitValues}, fieldsToUpdate)

    let requestOk = false;
    try {
      const motifRequest = await createMotif(updatedData);
      if (motifRequest?.status === 200) {
        if (motifRequest?.data?.id !== undefined && motifRequest?.data?.id !== null) {
          requestOk = true;
          navigate(`/motif-refus/liste`);
        }
      }
    } catch (ex) {
      console.error(ex)
    } finally {
      callback();
    }

  }

  return (
    <>
      <div className='card mb-5 mb-xl-10'>
        <div className='card-header border-0'>
          <div className='card-title m-0'>
            <h3 className='fw-bolder m-0'>Créer un motif de refus</h3>
          </div>
        </div>

        <div>
          <MotifRefusForm motifdId={null} data={modeleMotifRefusInitValues} submitForm={submitForm} />
        </div>
      </div>
    </>
  )
}

export default MotifRefusAddPage
